const scheduleConfig = {
  mySchedulePath: '/user/schedule',
  signInIntent: {
    storageKey: 'rootstech.schedule-sign-in-intent',
    // Pending selections are scoped to this tab and expire after 30 minutes.
    lifetimeMs: 30 * 60 * 1000,
  },
  workflowStates: [
    '0-ff8d0ed0-509f-11ed-bbe0-b7ddeba1268a', // Member Submissions Correlation
    '1-21ac8fe0-50a0-11ed-bbe0-b7ddeba1268a', // N.A. New Upload
    '2-68e486b0-50a0-11ed-bbe0-b7ddeba1268a', // LatAm New Upload
    '3-8f469370-50a0-11ed-bbe0-b7ddeba1268a', // Europe New Upload
    '4-ce0eda30-50a1-11ed-bbe0-b7ddeba1268a', // Europe East New Upload
    '5-f05a7450-50a1-11ed-bbe0-b7ddeba1268a', // Asia New Upload
    '6-05944300-50a2-11ed-bbe0-b7ddeba1268a', // Pacific New Upload
    '7-1935e580-50a2-11ed-bbe0-b7ddeba1268a', // Africa New Upload
    '8-31709820-50a2-11ed-bbe0-b7ddeba1268a', // Middle East New Upload
    '9-695a6810-50a2-11ed-bbe0-b7ddeba1268a', // Expo Hall New Upload
    '11-99431db0-50a2-11ed-bbe0-b7ddeba1268a', // Archives New Upload
    '12-ed359820-5166-11ed-8342-338b071c3bfc', // N.A. Review
    '13-11889b00-5167-11ed-8342-338b071c3bfc', // LatAm Review
    '14-41bf4990-5167-11ed-8342-338b071c3bfc', // Archives Review
    '16-7ad58b90-5167-11ed-8342-338b071c3bfc', // Expo Hall Review
    '17-8e181e20-5167-11ed-8342-338b071c3bfc', // Middle East Review
    '18-aa665d30-5167-11ed-8342-338b071c3bfc', // Asia Review
    '19-267e6660-5168-11ed-8342-338b071c3bfc', // Africa Review
    '20-34d33920-5168-11ed-8342-338b071c3bfc', // Pacific Review
    '21-4a132250-5168-11ed-8342-338b071c3bfc', // Europe East Review
    '22-4ebe5ae0-5168-11ed-8342-338b071c3bfc', // Europe Review
    '34-44489c70-517b-11ed-9a41-579a20e8b181', // Archives Curation
    '36-91592840-517b-11ed-9a41-579a20e8b181', // Expo Hall Curation
    '37-97d661b0-517b-11ed-9a41-579a20e8b181', // Middle East Curation
    '38-9d556500-517b-11ed-9a41-579a20e8b181', // Asia Curation
    '39-a3cb4b70-517b-11ed-9a41-579a20e8b181', // Africa Curation
    '40-c0b50730-517b-11ed-9a41-579a20e8b181', // LatAm Curation
    '41-c38bf4f0-517b-11ed-9a41-579a20e8b181', // N.A Curation
    '42-ccfd1a00-517b-11ed-9a41-579a20e8b181', // Pacific Curation
    '43-cfd73c10-517b-11ed-9a41-579a20e8b181', // Europe East Curation
    '44-d2d7aad0-517b-11ed-9a41-579a20e8b181', // Europe Curation
    '45-7c2e5840-517c-11ed-9a41-579a20e8b181', // Europe Publish Ready
    '46-7f63e0c0-517c-11ed-9a41-579a20e8b181', // Main Stage Publish Ready
    '47-82ab6aa0-517c-11ed-9a41-579a20e8b181', // Archives Publish Ready
    '48-854660d0-517c-11ed-9a41-579a20e8b181', // Asia Publish Ready
    '49-8938a9a0-517c-11ed-9a41-579a20e8b181', // Africa Publish Ready
    '50-8cbf8670-517c-11ed-9a41-579a20e8b181', // Expo Hall Publish Ready
    '51-91e03d20-517c-11ed-9a41-579a20e8b181', // Pacific Publish Ready
    '52-95bdec80-517c-11ed-9a41-579a20e8b181', // N.A Publish Ready
    '53-997d1760-517c-11ed-9a41-579a20e8b181', // LatAm Publish Ready
    '54-a02b24d0-517c-11ed-9a41-579a20e8b181', // Middle East Publish Ready
    '55-a3e03d90-517c-11ed-9a41-579a20e8b181', // Europe East Publish Ready
    '69-0279ab00-535f-11ed-89f1-b5840d7c88e8', // Assign for Review
    '72-9cb48c90-53a9-11ed-9e5f-65571a12dd2f', // RTCH Team Publish Ready RTCH Team (Session)
    '76-c862e080-12f7-11ef-ae39-bda99d568b45', // Signed Proposal
    '78-e0c6c8a0-9180-11ef-8b3d-a180798d3a11', // Initial Review
  ],
  previewLimit: 50,
  scrollRestore: {
    // How long a back-navigation keeps working to put the session card back where it was.
    // See docs/decisions/CDR-003-schedule-scroll-restoration.md
    timeoutMs: 5000,
  },
  calendarConfig: {
    // Individual calendar types from BSP
    calendars: {
      mainStage: 'main-stage',
      sessions: 'sessions',
      multiStage: 'multi-stage',
    },
  },
}

export default scheduleConfig
